import { translate } from "app/filters/i18nFilter";
import type {
    IosIdentifierType } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";
import {
    AppsIdentifiers
} from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";

const appIdentifierToTranslation = (appIdentifier: AppsIdentifiers): string => {
    return appIdentifier.toLowerCase().replace(" ", "_");
};

type BulkAddTextConfig = {
    header: string;
    text: string;
    counterText: string;
    placeholder: string;
    buttonText: string;
};

export const getBulkAddTextConfig = (entity: AppsIdentifiers): BulkAddTextConfig => {
    const placeholderType =
        entity === AppsIdentifiers.PackageName ? "android" : `ios.${appIdentifierToTranslation(entity)}`;

    return {
        header: translate("si.find_apps.filters.bulk_add.modal.title", { entity }),
        text: translate("si.find_apps.filters.bulk_add.modal.text", { entity }),
        counterText: translate("si.find_apps.filters.bulk_add.modal.counter.text", { entity }),
        placeholder: translate(`si.find_apps.filters.bulk_add.modal.placeholder.${placeholderType}`),
        buttonText: translate("si.find_apps.filters.bulk_add.button", { entity }),
    };
};

export const iosIdentifierTypeToAppsIdentifiers: {
    [key in IosIdentifierType]: AppsIdentifiers;
} = {
    trackIds: AppsIdentifiers.TrackId,
    bundleIds: AppsIdentifiers.BundleId,
};

export const parseInputValue = (value: string): string[] =>
    value
        .trim()
        .split(/\s|\s?,\s?/)
        .filter(Boolean);
